/**
 * @author Yaochao
 * @date 2021/8/12 12:00
 * @description
 */
import React from 'react'
import CorpApi from "../../public/corp_api";
import StepByStep from "./stepByStep";

const CorpBaseConfig = (WrappedComponent) => {

    return class extends React.Component {

        constructor(props) {
            super(props);
            this.state = {
                isComplete: 1
            }
        }

        componentWillMount() {
            CorpApi.getEnterpriseWechatAuthoriztionStuatus((data) => {
                let isComplete = data.isComplete;
                this.setState({
                    isComplete: isComplete
                })
            })
        }

        render() {
            let isComplete = this.state.isComplete;
            if (isComplete == 0) {
                return <StepByStep  {...this.props}/>
            } else if (isComplete > 0) {
                return <WrappedComponent {...this.props}/>
            } else {
                return <></>
            }
        }
    }
};

export default CorpBaseConfig